import { render, staticRenderFns } from "./ItemOpenMethodIcon.vue?vue&type=template&id=3bd0e154&scoped=true&"
import script from "./ItemOpenMethodIcon.vue?vue&type=script&lang=js&"
export * from "./ItemOpenMethodIcon.vue?vue&type=script&lang=js&"
import style0 from "./ItemOpenMethodIcon.vue?vue&type=style&index=0&id=3bd0e154&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd0e154",
  null
  
)

export default component.exports